module.exports = __webpack_public_path__ + "img/user-6.d346e269.svg";